export const enum EVENT_TYPES {
    SEQUENTIAL = 'sequential',
    CUSTOM = 'custom'
}

export const EVENT_TYPE_COLORS: Record<EVENT_TYPES, { primary: string, secondary: string }> = {
    [EVENT_TYPES.SEQUENTIAL]: {
        primary: '#007A55',
        secondary: '#D0FAE5',
    },
    [EVENT_TYPES.CUSTOM]: {
        primary: '#8200DB',
        secondary: '#F3E8FF',
    }
}

export const EVENT_NAMES: Record<EVENT_TYPES, string> = {
    [EVENT_TYPES.SEQUENTIAL]: 'Sequential Events',
    [EVENT_TYPES.CUSTOM]: 'Custom Events'
}

export const AVAILABLE_EVENT_TYPES = [
    {
        type: EVENT_TYPES.SEQUENTIAL,
        text: EVENT_NAMES[EVENT_TYPES.SEQUENTIAL],
        color: EVENT_TYPE_COLORS[EVENT_TYPES.SEQUENTIAL]
    },
    {
        type: EVENT_TYPES.CUSTOM,
        text: EVENT_NAMES[EVENT_TYPES.CUSTOM],
        color: EVENT_TYPE_COLORS[EVENT_TYPES.CUSTOM]
    }
]